import React, { Component } from 'react';

import Conteudo from '../../Conteudo';
import Title from '../../components/Title';

//import CadastroTarefa from './CadastroTarefa';
import ListaTarefasConfirmacao from './ListaTarefasConfirmacao';

import AuthProvider from '../../AuthProvider';

export default class extends Component {
  render() {
    return (
      <div>
        <Title value="Diego Rivera » Agenda » QrCode" />
        <AuthProvider>
          {(_undefined, containsRole) => {
            let children = [];

            if (
              containsRole([
                'admin',
                'conselheiro',
                'sindico'
              ])
            ) {
              children.push(ListaTarefasConfirmacao);
            }

            return (
              children.length && (
                <Conteudo>
                  {children.map((Child, i) => (
                    <Child key={i} />
                  ))}
                </Conteudo>
              )
            );
          }}
        </AuthProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/agenda/AgendaTarefasQrCode.js